module.exports = __webpack_public_path__ + "static/media/search-sample-4.4d813d7e.png";